import { render, staticRenderFns } from "./PracticaLeer.vue?vue&type=template&id=cad3536e&"
import script from "./PracticaLeer.vue?vue&type=script&lang=js&"
export * from "./PracticaLeer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports